"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", "px;\n  font-family: 'Yesteryear', cursive, sans-serif;\n  width: max-content;\n  position: relative;\n\n  /* font-weight: bold; */\n\n  &::after {\n    content: '\uD83D\uDD25';\n    position: absolute;\n    right: 0;\n    transform-origin: top right;\n    transform: translate(30%, 23%) scale(0.5) rotate(30deg);\n    z-index: -1;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents.default.div(_templateObject(), function (props) {
  return props.size;
});

var Logo = function Logo(_ref) {
  var size = _ref.size;
  return _react.default.createElement(Wrapper, {
    size: size || 40
  }, "flamb\xE9");
};

var _default = Logo;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@flambe/logo/dist/cjs/index.js
// module id = 74
// module chunks = 89649133384338 265272396218350 275328729791212